"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APITask = void 0;
const TranslatableTemplate_1 = require("./resources/TranslatableTemplate");
class APITask {
    constructor(taskSupplier, translations, mainDef, mainContent = [], subDef, subContent) {
        this.taskSupplier = taskSupplier;
        this.translations = translations;
        this.mainDef = mainDef;
        this.mainContent = mainContent;
        this.subDef = subDef;
        this.subContent = subContent;
        this.ttMain = new TranslatableTemplate_1.TranslatableTemplate(taskSupplier, mainDef, mainContent, translations);
        if (subDef) {
            this.ttSub = new APITask(taskSupplier, translations, subDef, subContent);
        }
    }
    setSubTask(subDef, subContent) {
        this.ttSub = (subDef) ? new APITask(this.taskSupplier, this.translations, subDef, subContent) : undefined;
    }
    setSubTaskInstance(sub) {
        this.ttSub = (sub && sub !== this) ? sub : undefined;
    }
    getSubTaskInstance() {
        return this.ttSub;
    }
    getMessage(bHTMLEntities = false) {
        let msg = this.ttMain.getMessage(bHTMLEntities);
        if (this.ttSub !== undefined) {
            msg += " -> " + this.ttSub.getMessage(bHTMLEntities);
        }
        return msg;
    }
    getMainMessage(bHTMLEntities = false) {
        return this.ttMain.getMessage(bHTMLEntities);
    }
    getSubMessage(bHTMLEntities = false) {
        return (this.ttSub) ? this.ttSub.getMessage(bHTMLEntities) : "";
    }
    getMostDetailedMessage(bHTMLEntities = false) {
        return (this.ttSub) ? this.ttSub.getMostDetailedMessage(bHTMLEntities) : this.getMessage(bHTMLEntities);
    }
    getKeys() {
        let ret = this.mainDef.key;
        if (this.ttSub) {
            ret += "." + this.ttSub.getKeys();
        }
        return ret;
    }
}
exports.APITask = APITask;
